import { Link } from 'react-router-dom';
import { siteBrand, siteNav, officialAccounts } from '@/mocks/siteData';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-5 md:px-8 lg:px-12 pt-14 md:pt-20 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-lg font-black">
                瞳
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteBrand.name}
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-200 max-w-md">
              {siteBrand.intro}
            </p>
            <p className="mt-5 font-mono text-xs text-accent-400">{siteBrand.slogan}</p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-xs tracking-[0.24em] uppercase text-background-400 mb-5">
              页面导航
            </p>
            <ul className="space-y-3">
              {siteNav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-100 hover:text-accent-300 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-xs tracking-[0.24em] uppercase text-background-400 mb-5">
              官方联系
            </p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="ri-mail-lock-line text-accent-400 mt-0.5"></i>
                <span className="text-background-100 break-all">
                  投稿邮箱：xiansuo@shentong-baoliao.com
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-links-line text-accent-400 mt-0.5"></i>
                <span className="text-background-100 break-all">
                  商务合作：business@shentong-baoliao.com
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-customer-service-2-line text-accent-400 mt-0.5"></i>
                <span className="text-background-100 break-all">
                  一般咨询：contact@shentong-baoliao.com
                </span>
              </li>
            </ul>

            <div className="mt-6 flex flex-wrap gap-2.5">
              {officialAccounts.map((account) => (
                <span
                  key={account.name}
                  title={account.handle}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-900 border border-secondary-800 text-background-100 hover:text-accent-300 hover:border-accent-600 transition-colors"
                >
                  <i className={`${account.icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <p className="font-mono text-xs text-background-400">
            © {year} {siteBrand.fullName} · 保留所有权利
          </p>
          <p className="font-mono text-xs text-background-400">
            本平台不收取任何投稿费用，请谨防冒名诈骗
          </p>
        </div>
      </div>
    </footer>
  );
}